import { z } from 'zod'

export type Explorer = {
  name: string
  baseUrl: string
  getAddressEvents: FunctionGetAddressEvents
}

export const eventIndexSchema = z.object({
  // "id": 2315883600054,
  id: z.number().int(),
  // "block_timestamp": 1730088552,
  block_timestamp: z
    .number()
    .int()
    .transform((v) => v * 1000),
  // "event_index": "23158836-54",
  event_index: z.string().regex(/^\d+-\d+$/),
  // "extrinsic_index": "23158836-2",
  extrinsic_index: z.union([z.literal(''), z.string().regex(/^\d+-\d+$/)]),
  // "phase": 0,
  phase: z.number().int(),
  // "module_id": "transactionpayment",
  module_id: z.string(),
  // "event_id": "TransactionFeePaid",
  event_id: z.string(),
  // "extrinsic_hash": "0xd7abca92a477a86f3b469f159272dc4c85689baaa69b58e17ee04732533228dc",
  extrinsic_hash: z.string(),
  // "finalized": true
  finalized: z.boolean(),
})

export type EventIndex = z.infer<typeof eventIndexSchema>

type FunctionGetAddressEvents = (parameters: {
  address: string
  fromBlock?: number
  toBlock?: number
  createHeaders?: () => Promise<Record<string, string>>
  onFetched?: (parameters: {
    events: readonly EventIndex[]
    toBlock: number
    completed: boolean
  }) => Promise<void>
}) => Promise<readonly EventIndex[]>
